module.exports = __webpack_public_path__ + "static/media/myphoto10.fd6516d2.jpg";